import { render, staticRenderFns } from "./UpNextPageDesktop.vue?vue&type=template&id=14339d7d&scoped=true&"
import script from "./UpNextPageDesktop.vue?vue&type=script&lang=js&"
export * from "./UpNextPageDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14339d7d",
  null
  
)

export default component.exports